//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BendFace",0,"ScCollector",0],[0,"BendType",1,0],[0,"BendingDirection",1,0],[0,"BendinsertPart",1,"TaggedObject",0],[0,"BlankPosition",1,0],[0,"BottomPlateClearance",1,0],[0,"CompositeInsert",1,0],[0,"ConceptDesign",1,0],[0,"DiePlateClearance",1,0],[1,"Extend",0,"Expression",0],[1,"ExtrudeEnd",0,"Expression",0],[1,"ExtrudeEnd1",0,"Expression",0],[1,"ExtrudeSketch",0,"Section",0],[1,"ExtrudeStart",0,"Expression",0],[1,"ExtrudeStart1",0,"Expression",0],[0,"ExtrudeTolerance",1,0],[0,"FalseBody",1,0],[0,"FlipTrimDirection",1,0],[1,"InsertComponent",0,"Assemblies.SelectComponentList",0],[1,"InsertToEdit",0,"Assemblies.SelectComponentList",0],[0,"InsertType",1,0],[0,"IntersectPlane",1,"Plane",0],[0,"IsAutoDatum",1,0],[0,"IsOffsetThickness",1,0],[0,"NewPartName",1,0],[0,"ParentNode",1,0],[0,"ParentPartName",1,0],[0,"PunchPlateClearance",1,0],[0,"ReName",1,0],[0,"StripperPlateClearance",1,0],[0,"Type",1,0],[0,"UseBottomPlateClearance",1,0],[0,"UseDiePlateClearance",1,0],[0,"UsePunchPlateClearance",1,0],[0,"UseStripperPlateClearance",1,0]],[[["faceOccs"],"SetFaces",{},1,0],[[],"AddInsertComponent",{},0,0]],[]];
SPLM.Tooling.BendInsertDesignBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.BendInsertDesignBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.BendInsertDesignBuilder.Types = Object.freeze({
    "Standard" : "Standard", "UserDefined" : "UserDefined", "Edit" : "Edit", "Delete" : "Delete"});

SPLM.Tooling.BendInsertDesignBuilder.BendingDirectionOption = Object.freeze({
    "Up" : "Up", "Down" : "Down"});

SPLM.Tooling.BendInsertDesignBuilder.BendTypeOption = Object.freeze({
    "Sbend" : "Sbend", "Abend" : "Abend", "Zbend" : "Zbend", "Vbend" : "Vbend", "Uzbend" : "Uzbend"});

SPLM.Tooling.BendInsertDesignBuilder.InsertTypeOption = Object.freeze({
    "Punch" : "Punch", "Die" : "Die", "PunchDie" : "PunchDie"});

SPLM.Tooling.BendInsertDesignBuilder.ParentOption = Object.freeze({
    "Sub" : "Sub"});

SPLM.Tooling.BendInsertDesignBuilder.BlankPositions = Object.freeze({
    "PunchPlate" : "PunchPlate", "StripperPlate" : "StripperPlate", "DiePlate" : "DiePlate", "TopPunchgPlate" : "TopPunchgPlate", "BottomPunchPlate" : "BottomPunchPlate"});

export default SPLM;